import { useEffect, useRef } from "preact/hooks";

/** Flag that turns false when the component unmounts; async continuations check it before touching state. */
export function useAlive(): { readonly current: boolean } {
  const alive = useRef(true);
  useEffect(() => {
    alive.current = true;
    return () => {
      alive.current = false;
    };
  }, []);
  return alive;
}
